// Делаем блоки калькуляторов серыми при загрузке страницы
$(".product__calc").each(function () {
    var calcBlock = $(this);
    if (
        $(this).data("val") == 0 ||
        $(this).find(".product__calc-num").text() ==
            $(this).find(".product__calc-minus").data("min")
    ) {
        calcBlock.addClass("disabled");
        if (calcBlock.parents(".product__bottom").length > 0) {
            calcBlock.parents(".product__bottom").addClass("grey-price");
        }

        console.log(calcBlock.parents(".self__key-item").find("p>span"));
        if (
            calcBlock.parents(".self__key-item").find("p>span").text() == "0₽"
        ) {
            calcBlock.parents(".self__key-item").addClass("disabled");
        }
    }

    if (calcBlock.find(".product__calc-num").text() == 0) {
        calcBlock.addClass("disabled_minus");
    }

    // Делаем невидимыми плюс и минус, если они достигли минимальных значений
    if (
        $(this).parents(".self__key-item").length > 0 &&
        $(this).data("val") != 0
    ) {
        calcBlock.removeClass("disabled");

        console.log(calcBlock.find(".product__calc-minus").data("min"));
        if (
            calcBlock.find(".product__calc-num").text() ==
            calcBlock.find(".product__calc-minus").data("min")
        ) {
            calcBlock.addClass("disabled_minus");
        }

        if (
            calcBlock.find(".product__calc-num").text() ==
            calcBlock.find(".product__calc-plus").data("max")
        ) {
            calcBlock.addClass("disabled_plus");
        }
    }
});

$(".self__general .checkbox input").each(function () {
    if ($(this).is(":checked")) {
        $(this).data("val", $(this).data("price"));
    }
});

$(".self__general .checkbox input").on("change", function () {
    if ($(this).is(":checked")) {
        $(this).data("val", $(this).data("price"));
    } else {
        $(this).data("val", 0);
    }
});

$(document).on(
    "click",
    ".product__calc-plus, .product__calc-minus",
    function (e) {
        e.preventDefault();
        var $this = $(this),
            calcBlock = $this.parent(),
            numBlock = calcBlock.find(".product__calc-num"),
            num = Number(numBlock.text());

        if ($("main").hasClass("self")) {
            var productBlock = $this.parents(
                    ".product, .sel-product, .self__key-item"
                ),
                productBlockId = productBlock.data("product"),
                productProd = productBlock.data("prod"),
                colichBlock = $this.parents(".self__key-item_colich");
            // Поиск блока с заданным ID в ВЫБРАННОМ
            var selProdBlock = $(document).find(
                    ".sel-product[data-product=" + productBlockId + "]"
                ),
                // Блок с калькулятором этого продукта
                selProdBlockCalc = selProdBlock.find(".product__calc");

            // Поиск блока с заданным ID в ОБЩЕМ списке
            var ProdBlock = $(document).find(
                    ".product[data-product=" + productBlockId + "]"
                ),
                // Блок с калькулятором этого продукта
                ProdBlockCalc = ProdBlock.find(".product__calc");
        }
        //
        if ($this.hasClass("product__calc-plus")) {
            calcBlock.removeClass("disabled_minus");
            if ($this.data("max") == undefined) {
                num++;
                if (calcBlock.parents(".self__key-item_colich").length > 0) {
                    calcBlock
                        .parents(".self__key-item_colich")
                        .removeClass("disabled");
                }
            } else {
                if (num + 1 == $this.data("max")) {
                    calcBlock.addClass("disabled_plus");
                }

                if (num >= $this.data("max")) {
                    num = num;
                } else {
                    num++;
                }
            }

            numBlock.text(num);
            calcBlock.removeClass("disabled");
            calcBlock.parents(".self__key-item_colich").removeClass("disabled");
            if (calcBlock.parents(".product__bottom").length > 0) {
                calcBlock.parents(".product__bottom").removeClass("grey-price");
            }

            // Добавление блока продукта в выбранное, изменение его цены
            if ($("main").hasClass("self")) {
                if (productBlock.hasClass("self__key-item")) {
                    setTimeout(function () {
                        productBlock.find("input[type=hidden]").val(num);
                    }, 100);
                }

                if (productBlock.hasClass("product")) {
                    // Изменение дата-атрибута цены текущего блока
                    ProdBlockCalc.data(
                        "val",
                        ProdBlockCalc.data("price") * num
                    );
                    // Если этот блок уже есть в выбранных
                    if (selProdBlock.length > 0) {
                        // Изменения данных в смежном блоке (в выбранном)
                        setTimeout(function () {
                            selProdBlockCalc
                                .find(".product__calc-num")
                                .text(num);
                            productCalc(
                                selProdBlockCalc,
                                ProdBlockCalc.data("val")
                            );
                            selProdBlockCalc.data(
                                "val",
                                ProdBlockCalc.data("val")
                            );

                            // Запись в скрытый инпут выбранного продукта
                            selProdBlock.find("input[type=hidden]").val(num);
                        }, 100);
                    } else {
                        // Если смежного продукта нет, то добавление или только него, или него и враппера
                        var menuType = productBlock
                                .parents(".self__grid-wp")
                                .data("type"),
                            menuCat = productBlock
                                .parents(".self__grid-wp")
                                .data("cat"),
                            menuName = productBlock
                                .parents(".self__grid-wp")
                                .find(".self__grid-title")
                                .text(),
                            menuItem = `<div class="sel-product sel-product_add" data-product="${productBlockId}" data-prod="${productProd}">
                                            <div class="sel-product__info">
                                                <p>${productBlock
                                                    .find(".product__name")
                                                    .text()}</p>
                                                <span>${replaceAlll(
                                                    productBlock
                                                        .find(
                                                            ".product__descr b"
                                                        )
                                                        .text(),
                                                    ".",
                                                    ""
                                                )}</span>
                                            </div>
                                            <div class="product__bottom-left">
                                                <div class="product__price">${productBlock
                                                    .find(".product__price")
                                                    .text()}</div>
                                                <div class="product__calc" data-price="${productBlock
                                                    .find(".product__calc")
                                                    .data(
                                                        "price"
                                                    )}" data-val="${productBlock
                                .find(".product__calc")
                                .data("val")}">
                                                    <a class="product__calc-minus" href="">
                                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M12.75 8.25H5.25C4.83579 8.25 4.5 8.58579 4.5 9C4.5 9.41421 4.83579 9.75 5.25 9.75H12.75C13.1642 9.75 13.5 9.41421 13.5 9C13.5 8.58579 13.1642 8.25 12.75 8.25Z" fill="white"></path>
                                                        </svg>
                                                    </a>
                                                    <div class="product__calc-num">${productBlock
                                                        .find(
                                                            ".product__calc-num"
                                                        )
                                                        .text()}</div>
                                                    <a class="product__calc-plus" href="">
                                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M12.75 8.25H9.75V5.25C9.75 5.05109 9.67098 4.86032 9.53033 4.71967C9.38968 4.57902 9.19891 4.5 9 4.5C8.80109 4.5 8.61032 4.57902 8.46967 4.71967C8.32902 4.86032 8.25 5.05109 8.25 5.25V8.25H5.25C5.05109 8.25 4.86032 8.32902 4.71967 8.46967C4.57902 8.61032 4.5 8.80109 4.5 9C4.5 9.19891 4.57902 9.38968 4.71967 9.53033C4.86032 9.67098 5.05109 9.75 5.25 9.75H8.25V12.75C8.25 12.9489 8.32902 13.1397 8.46967 13.2803C8.61032 13.421 8.80109 13.5 9 13.5C9.19891 13.5 9.38968 13.421 9.53033 13.2803C9.67098 13.1397 9.75 12.9489 9.75 12.75V9.75H12.75C12.9489 9.75 13.1397 9.67098 13.2803 9.53033C13.421 9.38968 13.5 9.19891 13.5 9C13.5 8.80109 13.421 8.61032 13.2803 8.46967C13.1397 8.32902 12.9489 8.25 12.75 8.25Z" fill="white"></path>
                                                        </svg>
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="sel-product__price">${triplets(
                                                productBlock
                                                    .find(".product__calc")
                                                    .data("val")
                                            )}<span>₽</span></div>
                                            <input type="hidden" name="foods[${productBlockId}]" value="${productBlock
                                .find(".product__calc-num")
                                .text()}">
                                            <a class="product__calc-remove" href="#">
                                                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10.2224 0.500842L6.33328 4.38993L2.44419 0.500842C2.18633 0.242979 1.83659 0.0981141 1.47192 0.0981138C1.10725 0.0981141 0.757509 0.242979 0.499646 0.500842C0.241784 0.758704 0.0969188 1.10844 0.0969188 1.47311C0.0969187 1.83779 0.241784 2.18752 0.499646 2.44539L4.38873 6.33447L0.499646 10.2236C0.241784 10.4814 0.0969187 10.8312 0.0969188 11.1958C0.0969188 11.5605 0.241784 11.9102 0.499646 12.1681C0.757509 12.426 1.10725 12.5708 1.47192 12.5708C1.83659 12.5708 2.18633 12.426 2.44419 12.1681L6.33328 8.27902L10.2224 12.1681C10.4802 12.426 10.83 12.5708 11.1946 12.5708C11.5593 12.5708 11.909 12.426 12.1669 12.1681C12.4248 11.9102 12.5696 11.5605 12.5696 11.1958C12.5696 10.8312 12.4248 10.4814 12.1669 10.2236L8.27782 6.33447L12.1669 2.44539C12.4248 2.18752 12.5696 1.83779 12.5696 1.47311C12.5696 1.10844 12.4248 0.758704 12.1669 0.500842C11.909 0.242979 11.5593 0.0981135 11.1946 0.0981132C10.83 0.0981128 10.4802 0.242979 10.2224 0.500842Z" fill="#D8D7E2"/>
                                                </svg>
                                            </a>
                                        </div>`;

                        setTimeout(function () {
                            // Только блок
                            if (
                                $(".self__selected").find(
                                    ".self__selected-wp[data-type=" +
                                        menuType +
                                        "]"
                                ).length > 0
                            ) {
                                $(
                                    ".self__selected .self__selected-wp[data-type=" +
                                        menuType +
                                        "] .self__selected-list"
                                ).append(menuItem);
                            } else {
                                // С враппером и тайтлом
                                $(".self__selected").append(`
                                    <div class="self__selected-wp" data-type="${menuType}" data-cat="${menuCat}">
                                        <div class="self__selected-subtitle">${menuName}</div>
                                        <div class="self__selected-list">
                                            ${menuItem}
                                        </div>
                                    </div>
                                `);
                            }

                            addSwipeEvent();
                        }, 50);
                    }
                    // Блок в выбранном
                } else if (productBlock.hasClass("sel-product")) {
                    // Изменение дата-атрибута цены текущего блока
                    selProdBlockCalc.data(
                        "val",
                        selProdBlockCalc.data("price") * num
                    );

                    // Изменения данных в смежном блоке (в общем меню)
                    setTimeout(function () {
                        ProdBlockCalc.find(".product__calc-num").text(num);
                        productCalc(
                            ProdBlockCalc,
                            selProdBlockCalc.data("val")
                        );
                        ProdBlockCalc.data("val", selProdBlockCalc.data("val"));

                        // Запись в скрытый инпут выбранного продукта
                        selProdBlock.find("input[type=hidden]").val(num);
                    }, 100);
                }
            }
        } else {
            if (productBlock.hasClass("self__key-item")) {
                setTimeout(function () {
                    productBlock.find("input[type=hidden]").val(num);
                }, 100);
            }

            calcBlock.removeClass("disabled_plus");

            if ($this.data("min") == undefined) {
                if (num == 1) {
                    num--;
                    numBlock.text(0);
                    calcBlock.addClass("disabled");
                    calcBlock.addClass("disabled_minus");
                    if (calcBlock.parents(".product__bottom").length > 0) {
                        calcBlock
                            .parents(".product__bottom")
                            .addClass("grey-price");
                    }
                } else if (num <= 0) {
                    numBlock.text(0);
                    num = 0;
                } else {
                    num--;
                    numBlock.text(num);
                }
            } else {
                // Добавление класса для блока калькулятора, если достигнуто минимальное значение
                if (num - 1 == $this.data("min")) {
                    // calcBlock.addClass('disabled');
                    calcBlock.addClass("disabled_minus");
                    setTimeout(function () {
                        if (
                            calcBlock
                                .parents(".self__key-item")
                                .find("p>span")
                                .text() == "0₽"
                        ) {
                            calcBlock
                                .parents(".self__key-item")
                                .addClass("disabled");
                        }
                    }, 50);
                }

                // Сделать цену серой, если нулевое значение
                if (
                    calcBlock.parents(".self__key-item_colich").length > 0 &&
                    num - 1 <= 0
                ) {
                    calcBlock
                        .parents(".self__key-item_colich")
                        .addClass("disabled");
                }

                if (num <= $this.data("min")) {
                    num = num;
                    // console.log((num - 1));
                    // console.log(Number($this.data('min')));
                } else {
                    if (num == 1) {
                        num--;
                        numBlock.text(0);
                        calcBlock.addClass("disabled");
                    } else if (num <= 0) {
                        numBlock.text(0);
                        num = 0;
                    } else {
                        num--;
                        numBlock.text(num);
                    }
                }
            }

            if ($("main").hasClass("self")) {
                if (productBlock.hasClass("product")) {
                    // Изменение дата-атрибута цены текущего блока
                    ProdBlockCalc.data(
                        "val",
                        ProdBlockCalc.data("price") * num
                    );
                    // Если этот блок уже есть в выбранных
                    if (selProdBlock.length > 0) {
                        // Изменения данных в смежном блоке (в выбранном)
                        setTimeout(function () {
                            selProdBlockCalc
                                .find(".product__calc-num")
                                .text(num);
                            productCalc(
                                selProdBlockCalc,
                                ProdBlockCalc.data("val")
                            );
                            selProdBlockCalc.data(
                                "val",
                                ProdBlockCalc.data("val")
                            );

                            // Запись в скрытый инпут выбранного продукта
                            selProdBlock.find("input[type=hidden]").val(num);
                        }, 100);
                    }

                    // Если колчиство продукта нулевое, то он удаляется из выбранного и ставится класс дисаблед в общем меню
                    if (num <= 0) {
                        ProdBlock.find(".product__calc").addClass("disabled");
                        if (
                            ProdBlock.find(".product__calc").parents(
                                ".product__bottom"
                            ).length > 0
                        ) {
                            ProdBlock.find(".product__calc")
                                .parents(".product__bottom")
                                .addClass("grey-price");
                        }
                        selProdBlockCalc.parents(".sel-product").fadeOut(250);
                        var selProdWp =
                            selProdBlockCalc.parents(".self__selected-wp");
                        selProdWpList = selProdWp.find(".self__selected-list");

                        setTimeout(function () {
                            selProdBlockCalc.parents(".sel-product").remove();
                            eatSumm();
                            selfSumm();
                            if (selProdWpList.find(".sel-product").length < 1) {
                                // Удаление категории в выбранном
                                selProdWp.remove();
                                // Удаление категории с весом
                                $(
                                    ".self__key_eat, .self__key_bezalk, .self__key_alk"
                                )
                                    .find(
                                        ".self__key-item[data-type=" +
                                            selProdWp.data("type") +
                                            "]"
                                    )
                                    .remove();
                            }
                        }, 300);
                    }
                } else if (productBlock.hasClass("sel-product")) {
                    // Изменение дата-атрибута цены текущего блока
                    selProdBlockCalc.data(
                        "val",
                        selProdBlockCalc.data("price") * num
                    );
                    // Изменения данных в смежном блоке (в выбранном)
                    setTimeout(function () {
                        ProdBlockCalc.find(".product__calc-num").text(num);
                        productCalc(
                            ProdBlockCalc,
                            selProdBlockCalc.data("val")
                        );
                        ProdBlockCalc.data("val", selProdBlockCalc.data("val"));

                        // Запись в скрытый инпут выбранного продукта
                        selProdBlock.find("input[type=hidden]").val(num);
                    }, 100);

                    var ProdBlock = $(document).find(
                        ".product[data-product=" + productBlockId + "]"
                    );
                    // Если колчиство продукта нулевое, то он удаляется из выбранного и ставится класс дисаблед в общем меню
                    if (num <= 0) {
                        ProdBlock.find(".product__calc").addClass("disabled");
                        if (
                            ProdBlock.find(".product__calc").parents(
                                ".product__bottom"
                            ).length > 0
                        ) {
                            ProdBlock.find(".product__calc")
                                .parents(".product__bottom")
                                .addClass("grey-price");
                        }
                        var selProdWp =
                                selProdBlockCalc.parents(".self__selected-wp"),
                            selProdWpCat = selProdWp.data("cat");
                        selProdWpList = selProdWp.find(".self__selected-list");

                        setTimeout(function () {
                            selProdBlockCalc.parents(".sel-product").remove();

                            eatSumm();
                            selfSumm();

                            if (selProdWpList.find(".sel-product").length < 1) {
                                // Удаление категории в выбранном
                                selProdWp.remove();

                                // Удаление категории с весом
                                $(".self__key[data-cat=" + selProdWpCat + "]")
                                    .find(
                                        ".self__key-item[data-type=" +
                                            selProdWp.data("type") +
                                            "]"
                                    )
                                    .remove();
                            }
                        }, 300);
                    }
                }
            }
        }
        //

        // Запись общей цены продукта в дата атрибут
        calcBlock.data("val", calcBlock.data("price") * num);

        colichBlock
            .find("p span")
            .text(separateNum(calcBlock.data("val")) + "₽");

        // Визуальный вывод цены продукта
        if (calcBlock.parents(".product, .sel-product")) {
            productCalc(calcBlock, calcBlock.data("val"));
        }

        // Суммирование только еды
        setTimeout(function (params) {
            eatSumm();
        }, 100);

        // Суммипрвание всех элементов и подсчет веса еды
        setTimeout(function () {
            selfSumm();
            makeEatCat();
            eatWeight();
            eatDrinks();
        }, 150);
    }
);

$(".self__key input[type=checkbox]").on("change", function (e) {
    var checkbox = $(this);
    if (checkbox.is(":checked")) {
        checkbox.data("val", checkbox.data("price"));
        // console.log(checkbox.data('val'));
    } else {
        checkbox.data("val", 0);
        // console.log(checkbox.data('val'));
    }
    // console.log(checkbox);
    selfSumm();
});

//  Визуализация цены ны продуктах
function productCalc(calculator, sumPrice) {
    calculator
        .parents(".product__bottom, .sel-product")
        .find(".product__bottom-right, .sel-product__price")
        .html(triplets(sumPrice) + "<span>₽</span>");
}

// Подсчет суммы всей еды + услуг на странице калькулятора
function selfSumm() {
    var allItems = $(document).find(".self__general [data-val]");
    var itogPrice = 0;
    var btnSum = $(".self__key-title_eat").data("val");

    allItems.each(function () {
        $(this).data("val");
        itogPrice = itogPrice + $(this).data("val");
        $(".self__key-title_summ span, .self__btn .ok span").text(
            separateNum(Math.round(itogPrice)) + "₽"
        );
        $(".self__key .input-summ").val(Math.round(itogPrice));

        // if ($('.self__btn').data('min').length != 0) {
        //     if (itogPrice > $('.self__btn').data('min')) {
        //         $('.self__btn').removeClass('btn-neok');
        //         $('.self__btn').attr('disabled', false);
        //     } else {
        //         $('.self__btn').addClass('btn-neok');
        //         $('.self__btn').attr('disabled', true);
        //     }
        // }
    });

    setTimeout(function () {
        if ($(".self__btn").data("min").length != 0) {
            if (btnSum >= $(".self__btn").data("min")) {
                $(".self__btn").removeClass("btn-neok");
                $(".self__btn").attr("disabled", false);
            } else {
                $(".self__btn").addClass("btn-neok");
                $(".self__btn").attr("disabled", true);
            }
        }
    }, 100);
}

// Подсчет суммы всей еды
function eatSumm() {
    var allProduct = $(document).find(
        ".self__wp .self__selected_desc .sel-product [data-val]"
    );
    var prodPrice = 0;

    // console.log(allProduct);

    allProduct.each(function () {
        $(this).data("val");
        prodPrice = prodPrice + $(this).data("val");
        $(".self__key-title_eat span").text(separateNum(prodPrice) + "₽");
        $(".self__key-title_eat .service-info i").text(
            separateNum(Math.round(prodPrice / $("#guest_col").val()))
        );
        $(".self__key-title_eat").data("val", prodPrice);
    });

    // Элементы с процентом от меню
    if ($(document).find(".self__key-item_service").length > 0) {
        $(document)
            .find(".self__key-item_service")
            .each(function () {
                var serviceItem = $(this);
                serviceItem.data(
                    "val",
                    $(".self__key-title_eat").data("val") *
                        (serviceItem.data("percent") / 100)
                );
                serviceItem
                    .find("p span")
                    .text(
                        separateNum(Math.round(serviceItem.data("val"))) + "₽"
                    );
            });
    }
}

// Создание категорий с весом еды
function makeEatCat() {
    $(".self__selected-wp").each(function () {
        var $this = $(this);
        if ($this.data("cat") == 1) {
            if (
                $(document).find(
                    ".self__key_eat .self__key-item[data-type=" +
                        $this.data("type") +
                        "]"
                ).length < 1
            ) {
                $(".self__key_eat").append(`
                <div class="self__key-item self__key-item_snacks" data-type="${$this.data(
                    "type"
                )}">${$this
                    .find(".self__selected-subtitle")
                    .text()}: <span></span></div>
                `);
            }
        } else if ($this.data("cat") == 2) {
            if (
                $(document).find(
                    ".self__key_bezalk .self__key-item[data-type=" +
                        $this.data("type") +
                        "]"
                ).length < 1
            ) {
                $(".self__key_bezalk").append(`
                <div class="self__key-item self__key-item_snacks" data-type="${$this.data(
                    "type"
                )}">${$this
                    .find(".self__selected-subtitle")
                    .text()}: <span></span></div>
                `);
            }
        } else if ($this.data("cat") == 3) {
            if (
                $(document).find(
                    ".self__key_alk .self__key-item[data-type=" +
                        $this.data("type") +
                        "]"
                ).length < 1
            ) {
                $(".self__key_alk").append(`
                <div class="self__key-item self__key-item_snacks" data-type="${$this.data(
                    "type"
                )}">${$this
                    .find(".self__selected-subtitle")
                    .text()}: <span></span></div>
                `);
            }
        }
    });
}

// Тысячные разряды
function triplets(str) {
    // \u202f — неразрывный узкий пробел
    if (str != undefined) {
        return str
            .toString()
            .replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1\u202f");
    }
}

// Подсчет веса еды
function eatWeight() {
    var productWeight = [],
        productWeightSummary = 0;

    $(document)
        .find(".self__selected_desc .self__selected-wp")
        .each(function () {
            var listId = $(this).data("type"),
                summType = [],
                summTypeResult = 0;

            $(this)
                .find(".sel-product[data-prod=1]")
                .find(".sel-product__info span")
                .each(function () {
                    var selProd = $(this)
                        .parents(".sel-product")
                        .find("input[type=hidden]")
                        .val();
                    summType.push(
                        Number(
                            $(this).text().replace(" гр", "").replace(" мл", "")
                        ) * selProd
                    );
                    summTypeResult = parseInt(eval(summType.join("+")));

                    return $(".self__key-item[data-type=" + listId + "]")
                        .find("span")
                        .text(
                            triplets(
                                Math.floor(
                                    summTypeResult / $("#guest_col").val()
                                )
                            ) + " гр"
                        );
                });

            // Добавляем все веса в массив
            productWeight.push(summTypeResult);

            // Суммирование элементов массива и деление его на количество гостей
            productWeightSummary = Math.floor(
                parseInt(eval(productWeight.join("+"))) / $("#guest_col").val()
            );
            // console.log(productWeightSummary);

            // Значение веса разделенное на разряды
            var separateSummWeight = separateUnits(productWeightSummary),
                // Сумма всех грамм и кг на человека
                summGramm = 0,
                summKg = 0;

            // В зависимости от длинны массива выделяем разряды числа (веса)
            switch (separateSummWeight.length) {
                case 1:
                    summGramm = separateSummWeight[0];
                    $(".self__key_eat .self__key-title span").text(
                        summGramm + "гр"
                    );
                    break;
                case 2:
                    summGramm = separateSummWeight[1] + separateSummWeight[0];
                    $(".self__key_eat .self__key-title span").text(
                        summGramm + "гр"
                    );
                    break;
                case 3:
                    summGramm =
                        separateSummWeight[0] +
                        separateSummWeight[1] +
                        separateSummWeight[2];
                    $(".self__key_eat .self__key-title span").text(
                        summGramm + "гр"
                    );
                    break;
                case 4:
                    summGramm =
                        separateSummWeight[1] +
                        separateSummWeight[2] +
                        separateSummWeight[3];
                    summKg = separateSummWeight[0];
                    $(".self__key_eat .self__key-title span").text(
                        summKg / 1000 + "кг " + summGramm + "гр"
                    );
                    break;
                case 5:
                    summGramm =
                        separateSummWeight[2] +
                        separateSummWeight[3] +
                        separateSummWeight[4];
                    summKg = separateSummWeight[0] + separateSummWeight[1];
                    $(".self__key_eat .self__key-title span").text(
                        summKg / 1000 + "кг " + summGramm + "гр"
                    );
                    break;
                case 6:
                    summGramm =
                        separateSummWeight[3] +
                        separateSummWeight[4] +
                        separateSummWeight[5];
                    summKg =
                        separateSummWeight[0] +
                        separateSummWeight[1] +
                        separateSummWeight[2];
                    $(".self__key_eat .self__key-title span").text(
                        summKg / 1000 + "кг " + summGramm + "гр"
                    );
                    break;
            }
        });
}

// Подсчет веса напитков
function eatDrinks() {
    for (let index = 2; index < 4; index++) {
        // console.log(index);

        var productWeight = [],
            productWeightSummary = 0,
            keyBlock = $(".self__key_bezalk");

        if (index == 3) {
            keyBlock = $(".self__key_alk");
        }

        $(document)
            .find(".self__selected_desc .self__selected-wp")
            .each(function () {
                var listId = $(this).data("type"),
                    summType = [],
                    summTypeResult = 0;

                $(this)
                    .find(".sel-product[data-prod=" + index + "]")
                    .find(".sel-product__info span")
                    .each(function () {
                        var selProd = $(this)
                            .parents(".sel-product")
                            .find("input[type=hidden]")
                            .val();
                        summType.push(
                            Number($(this).text().replace(" мл", "")) * selProd
                        );
                        summTypeResult = parseInt(eval(summType.join("+")));
                        // console.log($(this).text());
                        // console.log(selProd);
                        // console.log(summTypeResult);

                        return $(".self__key-item[data-type=" + listId + "]")
                            .find("span")
                            .text(
                                triplets(
                                    Math.round10(
                                        summTypeResult /
                                            $("#guest_col").val() /
                                            1000,
                                        -1
                                    )
                                ) + " л"
                            );
                    });

                // Добавляем все веса в массив
                productWeight.push(summTypeResult);

                // Суммирование элементов массива и деление его на количество гостей
                productWeightSummary = Math.floor(
                    parseInt(eval(productWeight.join("+"))) /
                        $("#guest_col").val()
                );
                // console.log(productWeightSummary);

                keyBlock
                    .find(".self__key-title span")
                    .text(Math.round10(productWeightSummary / 1000, -1) + " л");
            });
    }
}

// Разделение чисел на тысячи\сотни\десятки\единицы
function separateUnits(num) {
    var number = num.toString().split("");
    var multiplier = 1;

    for (var i = number.length - 1; i >= 0; i--) {
        number[i] *= multiplier;
        multiplier *= 10;
    }
    return number;
}

// Фиксированная кнопка сохранения проекта
if ($(document).find(".self__btn-fixed").length > 0) {
    $(window).on("load resize", function (e) {
        var fixPar = $(".self__right");
        var fixBtn = $(".self__btn-fixed");

        if ($(this).width() > 575) {
            fixBtn.css({
                right:
                    $(window).width() - (fixPar.offset().left + fixPar.width()),
                width: fixPar.width(),
            });
        } else {
            fixBtn.removeAttr("style");
        }
    });
}

//  Выбранное меню на мобилке
$(document).on("click", ".all-menu", function (e) {
    e.preventDefault();

    $(".applications__title .mob a").removeClass("current");
    $(this).addClass("current");
    $(".self__selected_mob").hide();
    $(".self__grid-wp").fadeIn();

    $(".self__left .self__buttons").show();

    setTimeout(function () {
        swiperSelfNav.swiperVariable.update();
    }, 100);
});

//  Всё меню на мобилке
$(document).on("click", ".selected-menu", function (e) {
    e.preventDefault();

    $(".applications__title .mob a").removeClass("current");
    $(this).addClass("current");
    $(".self__selected_mob").fadeIn();
    $(".self__grid-wp").hide();

    $(".self__left .self__buttons").hide();
});

$(window).on("resize", function (e) {
    if ($(window).width() > 991) {
        $(".self__selected_mob").hide();
    }
});

var swiperSelfNav = {};

// Фиксированные кнопки
if ($(document).find(".self__buttons").length > 0) {
    $(window).on("scroll resize", function (e) {
        var leftBlock = $(".self__left");
        var parBlock = $(".self__buttons");
        var fixBlock = $(".applications__buttons");

        if (parBlock.offset().top <= $(window).scrollTop()) {
            fixBlock.addClass("fixed");
            fixBlock.css({
                width: leftBlock.css("width"),
                left: leftBlock.offset().left,
            });
        } else {
            fixBlock.removeClass("fixed");
            fixBlock.removeAttr("style");
        }
    });

    if ($("main").hasClass("self")) {
        swiperSelfNav = {
            width: Infinity,
            swiperContainer: ".self__buttons .applications__buttons",
            swiperContainerWrap: ".self__buttons .applications__buttons-wrap",
            swiperContainerSlide: ".self__buttons .applications__btn",
            swiperVariable: undefined,
            swiperUpdateTime: undefined,
            swiperSettings: {
                slidesPerView: "auto",
                speed: 500,
                watchOverflow: true,
                freeMode: true,
                watchSlidesVisibility: true,
            },
        };

        initCustomSwiper(swiperSelfNav);
    }

    //  Переключение меню
    var lastId,
        topMenu = $(".self__buttons .applications__buttons-wrap"),
        topMenuHeight = topMenu.outerHeight() + 15,
        // All list items
        menuItems = topMenu.find("a"),
        // Anchors corresponding to menu items
        scrollItems = menuItems.map(function () {
            var item = $($(this).attr("href"));
            if (item.length) {
                return item;
            }
        });

    // Bind click handler to menu items
    // so we can get a fancy scroll animation
    menuItems.click(function (e) {
        var href = $(this).attr("href");
        if (href != "index.html") {
            offsetTop =
                href === "#" ? 0 : $(href).offset().top - topMenuHeight - 20;
            $("main").addClass("no_scroll_menu");
            menuItems.removeClass("active");
            $(this).addClass("active");
            setTimeout(function () {
                $("main").removeClass("no_scroll_menu");
            }, 300);
            $("html, body").stop().animate(
                {
                    scrollTop: offsetTop,
                },
                300
            );
            e.preventDefault();
        }
    });

    // Bind to scroll
    function scrollMenu() {
        // Get container scroll position
        var fromTop = $(this).scrollTop() + topMenuHeight + 50;
        // Get id of current scroll item
        var cur = scrollItems.map(function () {
            if ($(this).offset().top < fromTop) return this;
        });

        // Get the id of the current element
        cur = cur[cur.length - 1];
        var id = cur && cur.length ? cur[0].id : "";

        if (lastId !== id) {
            lastId = id;
            // Set/remove active class
            menuItems
                .removeClass("active")
                .filter("[href='#" + id + "']")
                .addClass("active");
            swiperSelfNav.swiperVariable.slideTo(
                $(
                    '.applications__buttons-wrap .applications__btn[href="#' +
                        id +
                        '"]'
                ).data("index")
            );
        }
    }

    $(window).scroll(function () {
        if (!$("main").hasClass("no_scroll_menu")) {
            scrollMenu();
        }
    });

    // $(window).scroll(function () {
    //     // Get container scroll position
    //     var fromTop = $(this).scrollTop() + topMenuHeight + 50;
    //     // Get id of current scroll item
    //     var cur = scrollItems.map(function () {
    //         if ($(this).offset().top < fromTop)
    //             return this;
    //     });

    //     // Get the id of the current element
    //     cur = cur[cur.length - 1];
    //     var id = cur && cur.length ? cur[0].id : "";

    //     if (lastId !== id) {
    //         lastId = id;
    //         // Set/remove active class
    //         menuItems
    //             .removeClass("active").filter("[href='#" + id + "']").addClass("active");
    //         swiperSelfNav.swiperVariable.slideTo($('.applications__buttons-wrap .applications__btn[href="#' + id + '"]').data('index'));
    //     }
    // });
    // ////////////////
}

// Модалка уверены ли вы в удалении
$(document).on("click", ".redirect-link", function (e) {
    e.preventDefault();

    youShure.openModal();

    if ($("#you-shure .you-shure__form").find(".modal-title").length == 0) {
        $("#you-shure .you-shure__form").prepend(
            `<div class="modal-title">Создать новый расчет</div>`
        );
    }

    $("#you-shure .you-shure__form p")
        .text(
            "При выборе другой даты / зала необходимо создать новый расчет. Текущие изменения в расчете (блюда, напитки, услуги) не будут сохранены."
        )
        .css("text-align", "center");
    $("#you-shure .you-shure__form .btn-sub").text("Новый расчет");
    $(this).addClass("preredirect");
});

// Предзаполнение полей по кукии cookies
function getCookie(name) {
    let matches = document.cookie.match(
        new RegExp(
            "(?:^|; )" +
                name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
                "=([^;]*)"
        )
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, options = {}) {
    options = {
        path: "/",
        // при необходимости добавьте другие значения по умолчанию
        ...options,
    };

    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }

    let updatedCookie =
        encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (let optionKey in options) {
        updatedCookie += "; " + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
        }
    }

    document.cookie = updatedCookie;
}

function deleteCookie(name) {
    setCookie(name, "", {
        "max-age": -1,
    });
}

// Удаляем куки при загрузке страницы
if (!$("main").hasClass("calculation")) {
    $(window).on("load", function () {
        deleteCookie("guest_count1");
        deleteCookie("zal_id1");
        deleteCookie("redirectino");
        // deleteCookie('date_val1');
        // console.log(getCookie('guest_count1'));
        // console.log(getCookie('zal_id1'));
        console.log(getCookie("redirectino"));
        // console.log(getCookie('date_val1'));
    });
} else if (!$("main").hasClass("clients")) {
    deleteCookie("setDate");
    deleteCookie("packetDay");
    deleteCookie("packetMonth");
    deleteCookie("packetYear");
}

// Удаление элементов меню по клику на крестик
$(document).on("click", ".product__calc-remove", function (e) {
    e.preventDefault();

    var $this = $(this),
        thisPar = $this.parents(".sel-product, .product");
    // Установка значения равного нулю и событие клик, чтоб сработали скрипты
    thisPar.find(".product__calc-num").text(0);
    thisPar.find(".product__calc-minus").click();
});

// Изменение ссылок в модалке, если страница расчета
if ($("main").hasClass("self")) {
    $(window).on("load", function () {
        var calcForm = $("#calc-packet"),
            self = $(".self__wp"),
            zalLink = calcForm.find(".self__general-line.zal a"),
            dayLink = calcForm.find(".self__general-line.date a");

        zalLink
            .removeClass("calc-packet-data")
            .addClass("redirect-link")
            .attr("href", self.find(".self__general-line_zal a").attr("href"));
        dayLink
            .removeClass("calc-packet-data")
            .addClass("redirect-link redirect-link_date")
            .attr("href", self.find(".self__general-line_date a").attr("href"));
        dayLink.attr(
            "data-day",
            self.find(".self__general-line_zal a").data("day")
        );
        dayLink.attr(
            "data-month",
            self.find(".self__general-line_zal a").data("month")
        );
        dayLink.attr(
            "data-year",
            self.find(".self__general-line_zal a").data("year")
        );
    });
}

// Функции округления до большего
function decimalAdjust(type, value, exp) {
    // Если степень не определена, либо равна нулю...
    if (typeof exp === "undefined" || +exp === 0) {
        return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // Если значение не является числом, либо степень не является целым числом...
    if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) {
        return NaN;
    }
    // Сдвиг разрядов
    value = value.toString().split("e");
    value = Math[type](+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp)));
    // Обратный сдвиг
    value = value.toString().split("e");
    return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
}

// Десятичное округление к ближайшему
if (!Math.round10) {
    Math.round10 = function (value, exp) {
        return decimalAdjust("round", value, exp);
    };
}

// Десятичное округление вверх
if (!Math.ceil10) {
    Math.ceil10 = function (value, exp) {
        return decimalAdjust("ceil", value, exp);
    };
}

// Десятичное округление к ближайшему
if (!Math.round10) {
    Math.round10 = function (value, exp) {
        return decimalAdjust("round", value, exp);
    };
}
/////////////////////////////////////////

var scrollObj = "";

// Смещение элемента свайпом для его удаления

// Функция подвешивания события и удаления старого при добавлении элементов
function addSwipeEvent() {
    scrollObj = document.querySelectorAll(".sel-product_add, .product_add");

    for (let index = 0; index < scrollObj.length; index++) {
        const selItem = scrollObj[index];
        selItem.removeEventListener("touchstart", handleTouchStart, false);
        selItem.removeEventListener("touchmove", handleTouchMove, false);
        selItem.removeEventListener("touchend", touchEnded, false);

        selItem.addEventListener("touchstart", handleTouchStart, false);
        selItem.addEventListener("touchmove", handleTouchMove, false);
        selItem.addEventListener("touchend", touchEnded, false);
    }
}

if ($(window).width() < 768) {
    addSwipeEvent();
}

var xDown = null;
var yDown = null;
var xDownLast = null;

// Окончание качания
function touchEnded(evt) {
    var thisEl = this;
    // добавление транзишена, чтоб карточка назад плавно уехала
    thisEl.style.transition = "0.25s";

    // Обнуление последнего положения касания
    setTimeout(function () {
        xDownLast = null;
    }, 20);

    // Если смещение свайпа больше чем на 150пх, то позиция удаляется из выбранного
    if (xDownLast < -150) {
        // Разные вариаеты денйствий для разных карточек
        if (thisEl.classList.contains("product_add")) {
            thisEl.style.transform = "translateX(0px)";
        } else {
            thisEl.style.transform = "translateX(-101%)";
        }

        // Поиск клавиши удаления и клик по ней
        setTimeout(function () {
            console.log($(thisEl));
            $(thisEl).find(".product__calc-remove").click();
        }, 150);
    } else {
        // Возвращение в исходное положение при малом свайпе
        thisEl.style.transform = "translateX(0px)";
    }
}

function getTouches(evt) {
    return (
        evt.touches || // чистый API JS
        evt.originalEvent.touches
    ); // jQuery
}

function handleTouchStart(evt) {
    xDown = null;
    yDown = null;
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
    this.style.transition = "0s";
}

function handleTouchMove(evt) {
    var transformEl = evt.touches[0].clientX - xDown;

    xDownLast = transformEl;

    if (transformEl >= 0) {
        this.style.transform = "translateX(0px)";
    } else {
        this.style.transform = "translateX(" + transformEl + "px)";
    }
}

// $(document).on('click', function (e) {
//     e.preventDefault();

//     console.log($('#current_order_id').val());

//     // $(this).removeAttr('style');
// });

// Кнопка печати в тайтле страницы

$(".self__wp .print_self").on("click", function (e) {
    e.preventDefault();

    var $this = $(this),
        selectedMenu = {},
        selectedServices = {};
    $this.css({
        opacity: 0.5,
        cursor: "not-allowed",
    });

    $(".self__selected_desc")
        .find(".sel-product")
        .each(function (e) {
            var thisInput = $(this).find("input");
            selectedMenu[$(this).data("product")] = thisInput.val();
        });

    $(".self__key")
        .find(".self__key-item input[type=hidden], input[type=checkbox]")
        .each(function () {
            if ($(this).is(":checked")) {
                selectedServices[$(this).data("id")] = 1;
            } else if ($(this).attr("type") == "hidden") {
                selectedServices[$(this).data("id")] = $(this).val();
            }
        });

    if ($("main").hasClass("self_viewing")) {
        var dataAjax = {
                _token: tokenData,
            },
            ajaxUrl = "/option/" + $("#current_order_id").val() + "/pdf";
    } else {
        var dataAjax = {
                name: $("#var_count").val(),
                foods: selectedMenu,
                services: selectedServices,
                date: $("#date_val1").val(),
                guest_count: $("#guest_col").val(),
                room_id: $("#selected_zal").val(),
                _token: tokenData,
            },
            ajaxUrl = "/order/" + $("#order_key").val() + "/option/pdf";
    }

    if ($(document).find("#option_id").length > 0) {
        dataAjax["option_id"] = $("#option_id").val();
    } else {
        dataAjax["pack_id"] = $("#pack_zal").val();
    }

    $.ajax({
        url: ajaxUrl,
        type: "POST",
        data: dataAjax,
        success: function (data) {
            var result = data;

            $this.removeAttr("style");

            console.log(result);
            openPdf.openModal();
            $("#open_pdf").find(".btn").attr("href", result);
        },
    });
});
